import { getPermissions } from '../lib/APIClient'
import ActionTypes from './ActionTypes';

// #TODO lacking error-control

function fetchPermissions() {
  return (dispatch) => {
    getPermissions((e, data) => {
      if (e) {
        console.error(`Error found while fetching login data: ${  e}`)
        dispatch({ type: ActionTypes.GET_PERMISSIONS, payload: {} })
      }
      else {
        dispatch({ type: ActionTypes.GET_PERMISSIONS, payload: data })
      }
    })
  }
}

export default fetchPermissions
